import React from "react"
import { ReactComponent as Study } from "images/icons/study.svg"
import { FlexGrid, FlexRow, FlexCol } from "components/FlexGrid"
import { ReactComponent as Book } from "images/icons/book-study.svg"
import { ReactComponent as Temple } from "images/icons/temple-study.svg"
import { ReactComponent as House } from "images/icons/house-study.svg"
import {
  WhyModuleContainer,
  WhyModuleMainColumn,
  WhyTitle,
  Subtext,
  WhyTeaser,
  SlantMask,
  Mask1,
  Mask2,
} from "./style"

const WhyModule = ({ title, text, teasers }) => {
  return (
    <WhyModuleContainer className="why">
      <SlantMask />
      <WhyModuleMainColumn>
        <WhyTitle>{title}</WhyTitle>
        <Subtext>{text}</Subtext>
        <FlexGrid fullWidth gap={[45, 30, 40, 40]} rowGap={[45, 50, 60, 70]}>
          <FlexRow>
            {teasers.map((teaser, index) => {
              return (
                <FlexCol xs={12} sm={6} md={4} key={index}>
                  <WhyTeaser
                    title={teaser.title}
                    excerpt={teaser.excerpt}
                    link={teaser.link}
                    innerLinkText={teaser.innerLinkText}
                    noImg
                    centered
                  >
                    {teaser.icon}
                  </WhyTeaser>
                </FlexCol>
              )
            })}
          </FlexRow>
        </FlexGrid>
      </WhyModuleMainColumn>
    </WhyModuleContainer>
  )
}

export default WhyModule

WhyModule.defaultProps = {
  title: `Why Study In Canberra`,
  text: `Study in Canberra and earn a first class education that is recognised around the world. Our universities, training institutions, colleges and schools deliver high quality education and produce influential graduates.`,
  teasers: [
    {
      title: "Most educated city",
      excerpt:
        "The capital has the highest proportion of people who have completed year 12 studies, or an equivalent.",
      link: "/",
      innerLinkText: "Read more",
      icon: <Book />,
    },
    {
      title: "World Class institutions",
      excerpt: `World-class universities, vocational education and training institutions, a high achieving school system and flexible pathways.
      `,
      link: "/",
      innerLinkText: "Read more",
      icon: <Temple />,
    },
    {
      title: "On Campus Accommodation",
      excerpt:
        "Canberra offers the highest proportion of on-campus student accommodation in Australia.",
      link: "/",
      innerLinkText: "Read more",
      icon: <House />,
    },
    {
      title: "Intellectual Capital",
      excerpt: `The highest proportion of people who have completed year 12 studies, or an equivalent.
        `,
      link: "/",
      innerLinkText: "Read more",
      icon: <Book />,
    },
    {
      title: "Transport & Infrastructure",
      excerpt: `A truly integrated public transport network provides quick and reliable ways to travel around the city.
      `,
      link: "/",
      innerLinkText: "Read more",
      icon: <Temple />,
    },
    {
      title: "Sustainability",
      excerpt:
        "Due to our proximity to the natural environment sustainability is one of the key aspects of living in Canberra.",
      link: "/",
      innerLinkText: "Read more",
      icon: <House />,
    },
  ],
}
